module.exports = __webpack_public_path__ + "static/media/LB_logo.925951af.svg";